export default __webpack_public_path__ + "static/media/contractAndPen.f40af3f8.svg";